/* Bright Futures Counseling wishlist (counselor saves resources, sends list to an administrator). */
(function () {
  if (window.BFCWL) return;
  var KEY = 'bfc_wishlist_v1';
  var MAX_ITEMS = 100;
  var cfg = window.BFCWL_CFG || {};
  var pageUrl = cfg.page || '/pages/wishlist';
  var mem = [];

  function read() {
    try {
      var raw = localStorage.getItem(KEY);
      var a = raw ? JSON.parse(raw) : [];
      return Array.isArray(a) ? a.filter(function (x) { return x && x.h; }) : [];
    } catch (e) { return mem.slice(); }
  }
  function write(a, silent) {
    mem = a.slice(0, MAX_ITEMS);
    try { localStorage.setItem(KEY, JSON.stringify(mem)); } catch (e) {}
    refresh();
    if (!silent) {
      try { document.dispatchEvent(new CustomEvent('bfc-wl-change', { detail: { items: mem.slice() } })); } catch (e) {}
    }
  }
  function idx(a, h) { for (var i = 0; i < a.length; i++) if (a[i].h === h) return i; return -1; }
  function clean(item) {
    return {
      h: String(item.h || ''),
      v: item.v ? String(item.v) : '',
      t: String(item.t || '').slice(0, 200),
      i: String(item.i || ''),
      p: parseInt(item.p, 10) || 0,
      q: Math.max(1, Math.min(99, parseInt(item.q, 10) || 1)),
      a: item.a || Date.now()
    };
  }

  var api = {
    items: read,
    count: function () { return read().length; },
    has: function (h) { return idx(read(), h) > -1; },
    add: function (item) {
      var a = read(); var c = clean(item); var i = idx(a, c.h);
      if (i > -1) { a[i] = Object.assign(a[i], { v: c.v || a[i].v, t: c.t || a[i].t, i: c.i || a[i].i, p: c.p || a[i].p }); }
      else { if (a.length >= MAX_ITEMS) return false; a.unshift(c); }
      write(a); return true;
    },
    remove: function (h) { var a = read(); var i = idx(a, h); if (i > -1) { a.splice(i, 1); write(a); } },
    toggle: function (item) { if (api.has(item.h)) { api.remove(item.h); return false; } return api.add(item); },
    setQty: function (h, q) { var a = read(); var i = idx(a, h); if (i > -1) { a[i].q = Math.max(1, Math.min(99, parseInt(q, 10) || 1)); write(a); } },
    patch: function (h, p) { var a = read(); var i = idx(a, h); if (i > -1) { a[i] = Object.assign(a[i], p); write(a, true); } },
    replaceAll: function (list) { write(list.map(clean)); },
    money: function (cents) {
      var n = (parseInt(cents, 10) || 0) / 100;
      try { return n.toLocaleString('en-US', { style: 'currency', currency: 'USD' }); } catch (e) { return '$' + n.toFixed(2); }
    },
    /* Bundle tiers like "3:5,5:10,10:15,20:20" (minimum items : percent off). Returns percent for a quantity. */
    tierPercent: function (qty) {
      var best = 0;
      String(cfg.tiers || '').split(',').forEach(function (t) {
        var p = t.split(':'); var min = parseInt(p[0], 10), pct = parseFloat(p[1]);
        if (min && pct && qty >= min && pct > best) best = pct;
      });
      return best;
    },
    /* Compact share code: base36 variant id, optional *qty, joined by "." */
    encode: function (list) {
      return list.filter(function (x) { return x.v; }).map(function (x) {
        var s = Number(x.v).toString(36);
        return x.q > 1 ? s + '*' + x.q : s;
      }).join('.');
    },
    decode: function (code) {
      var out = [];
      String(code || '').split('.').forEach(function (part) {
        var m = /^([0-9a-z]{1,14})(?:\*(\d{1,2}))?$/.exec(part);
        if (!m) return;
        var v = parseInt(m[1], 36);
        if (!v || !isFinite(v)) return;
        out.push({ v: String(v), q: Math.max(1, Math.min(99, parseInt(m[2] || '1', 10))) });
      });
      return out.slice(0, MAX_ITEMS);
    },
    /* Open the cart drawer by clicking the header cart button (the cart app intercepts that click).
       If nothing intercepts it (app still loading or busy), cancel the navigation and retry a few times,
       then fall back to the /cart page. */
    openCart: function () {
      var tries = 0, clicks = 0;
      function findBtn() {
        var els = document.querySelectorAll('a.header__btn-cart, [data-js-popup-button="cart"]');
        for (var i = 0; i < els.length; i++) { var r = els[i].getBoundingClientRect(); if (r.width > 0 && r.height > 0) return els[i]; }
        return null;
      }
      function tryClick() {
        var el = findBtn();
        if (!el) { window.location.href = '/cart'; return; }
        var unhandled = false;
        function guard(e) {
          if (e.target === el || el.contains(e.target)) {
            if (!e.defaultPrevented) { e.preventDefault(); unhandled = true; }
          }
        }
        window.addEventListener('click', guard, false);
        el.click();
        window.removeEventListener('click', guard, false);
        if (unhandled) {
          if (++clicks >= 4) { window.location.href = '/cart'; return; }
          setTimeout(tryClick, 600);
        }
      }
      (function waitForApp() {
        var app = window.fcsb;
        if (app && typeof app.openMiniCart === 'function' && typeof app.fetchCart === 'function') {
          /* Cart app API: reload the cart, then open its drawer (which has Generate Quote). */
          Promise.resolve().then(function () { return app.fetchCart(); })
            .then(function () { app.openMiniCart(); }, function () { tryClick(); });
          return;
        }
        if (tries++ >= 25) return tryClick();
        setTimeout(waitForApp, 200);
      })();
    },
    /* Open the Purchase Orders app's quote form directly (more reliable than the cart drawer's Generate Quote).
       Uses the hidden .save-purchase-order-w3 link in the footer. Falls back to the cart drawer. */
    openQuote: function (opts) {
      if (cfg.estimates && window.BFCEstimate) { window.BFCEstimate.open(opts || {}); return; }
      var tries = 0;
      (function attempt() {
        var a = document.querySelector('.save-purchase-order-w3');
        if (a && window.jQuery) {
          a.click();
          setTimeout(function () { if (!document.getElementById('purchase-order-popup')) api.openCart(); }, 500);
          return;
        }
        if (tries++ >= 15) return api.openCart();
        setTimeout(attempt, 200);
      })();
    },
    refresh: refresh
  };
  window.BFCWL = api;

  function refresh() {
    var a = read(); var saved = {};
    a.forEach(function (x) { saved[x.h] = 1; });
    var btns = document.querySelectorAll('[data-bfc-wl]');
    for (var i = 0; i < btns.length; i++) {
      var on = !!saved[btns[i].getAttribute('data-h')];
      btns[i].classList.toggle('is-saved', on);
      btns[i].setAttribute('aria-pressed', on ? 'true' : 'false');
    }
    var counts = document.querySelectorAll('[data-bfc-wl-count]');
    for (var j = 0; j < counts.length; j++) {
      counts[j].textContent = a.length;
      counts[j].hidden = a.length === 0;
    }
  }

  var toastEl, toastTimer;
  function toast(saved) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'bfc-wl-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.innerHTML = '';
    var msg = document.createElement('span');
    msg.textContent = saved === 'full' ? 'Your wishlist is full (100 resources)' : saved ? 'Saved to your wishlist' : 'Removed from your wishlist';
    toastEl.appendChild(msg);
    if (saved) {
      var link = document.createElement('a');
      link.href = pageUrl; link.textContent = 'View wishlist';
      toastEl.appendChild(link);
    }
    toastEl.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-on'); }, 3200);
  }

  function itemFrom(btn) {
    var v = btn.getAttribute('data-v');
    if (btn.hasAttribute('data-bfc-wl-form')) {
      var form = btn.closest('form') || document.querySelector('form[action*="/cart/add"]');
      var input = form && form.querySelector('[name="id"]');
      if (input && input.value) v = input.value;
    }
    return { h: btn.getAttribute('data-h'), v: v, t: btn.getAttribute('data-t'), i: btn.getAttribute('data-i'), p: btn.getAttribute('data-p') };
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-bfc-wl]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var item = itemFrom(btn);
    if (!item.h) return;
    var wasSaved = api.has(item.h);
    var ok = api.toggle(item);
    if (!wasSaved && !ok) { toast('full'); return; }
    toast(!wasSaved);
  }, true);

  window.addEventListener('storage', function (e) { if (e.key === KEY) { refresh(); try { document.dispatchEvent(new CustomEvent('bfc-wl-change', { detail: { items: read() } })); } catch (x) {} } });

  var pending;
  function schedule() { clearTimeout(pending); pending = setTimeout(refresh, 120); }
  function start() {
    refresh();
    if (window.MutationObserver) {
      new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          var n = muts[i].addedNodes;
          for (var j = 0; j < n.length; j++) {
            if (n[j].nodeType === 1 && (n[j].hasAttribute('data-bfc-wl') || (n[j].querySelector && n[j].querySelector('[data-bfc-wl]')))) { schedule(); return; }
          }
        }
      }).observe(document.body, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
